module.exports = __webpack_public_path__ + "media/customizations/sevenhills/logo-new-364ff073a66850f66be677fd28b70c7f.png";